import { ReactNode, forwardRef, ComponentPropsWithoutRef } from 'react'
import { useDialogState } from '@/hooks'

/**
 * Container Root 组件
 * Headless 容器组件，提供对话显示状态的逻辑
 */
interface ContainerRootProps extends ComponentPropsWithoutRef<'div'> {
  children: ReactNode
}

const ContainerRoot = forwardRef<HTMLDivElement, ContainerRootProps>(
  ({ children, ...props }, ref) => {
    const state = useDialogState()

    if (!state.isVisible || !state.currentDialogue) {
      return null
    }

    const theme = state.currentDialogue.metadata?.theme || 'default'

    return (
      <div ref={ref} data-theme={theme} {...props}>
        {children}
      </div>
    )
  }
)

ContainerRoot.displayName = 'Container.Root'

/**
 * Container Background 组件
 * 可选的背景层组件
 */
interface ContainerBackgroundProps extends ComponentPropsWithoutRef<'div'> {}

const ContainerBackground = forwardRef<HTMLDivElement, ContainerBackgroundProps>(
  (props, ref) => {
    return <div ref={ref} {...props} />
  }
)

ContainerBackground.displayName = 'Container.Background'

export const Container = {
  Root: ContainerRoot,
  Background: ContainerBackground,
}
